"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullSync = fullSync;
exports.getSyncLogDetail = getSyncLogDetail;
exports.getSyncLogList = getSyncLogList;
exports.getSyncStatistics = getSyncStatistics;
exports.triggerSync = triggerSync;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 同步日志列表
function getSyncLogList(query) {
  return (0, _request.default)({
    url: '/sync-log/list',
    method: 'get',
    params: query
  });
}

// 同步日志详情
function getSyncLogDetail(id) {
  return (0, _request.default)({
    url: "/sync-log/".concat(id),
    method: 'get'
  });
}

// 手动触发同步
function triggerSync(syncType) {
  return (0, _request.default)({
    url: '/sync-log/trigger',
    method: 'post',
    data: {
      syncType: syncType
    }
  });
}

// 全量同步
function fullSync() {
  return (0, _request.default)({
    url: '/sync-log/full-sync',
    method: 'post'
  });
}

// 获取同步统计
function getSyncStatistics() {
  return (0, _request.default)({
    url: '/sync-log/statistics',
    method: 'get'
  });
}